<ng-container *ngIf="params?.data; else loader">{{params?.valueFormatted || params?.value}}</ng-container>

<ng-template #loader>
    <ngx-skeleton-loader 
        count="1" 
        appearance="line"
        [theme]="{ 
            'width': '100%', 
            'height': '30px', 
            'margin': 'auto',
            'vertical-align': 'middle',
            'background-color': 'var(--ag-skeleton-background-color)'
        }">
    </ngx-skeleton-loader>
</ng-template>
